import { render, staticRenderFns } from "./update_house_modal.vue?vue&type=template&id=b6a9485a"
import script from "./update_house_modal.vue?vue&type=script&lang=js"
export * from "./update_house_modal.vue?vue&type=script&lang=js"
import style0 from "./update_house_modal.vue?vue&type=style&index=0&id=b6a9485a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports